<template lang="pug">
</template>

<script>

import RatingReviewModal from '@md/rating-reviews/components/modal'

export default {
  data() {
    return {
      mustShowModal: window.must_show_rating_review_modal
    }
  },

  methods: {
    openModal() {
      const pr = arg => new Promise((resolve, reject) => {
        if (arg) {
          resolve(arg);
          console.log('resolve modal', arg)
          return;
        }
        console.log('reject modal')
        reject(arg);
      }).then(() => {
        console.log('then in promise modal')
        // this.updateResult();
      });
      this.$modal.show(
        RatingReviewModal,
        {
          // transaction: {
          //   client: this.item,
          // },
          promise: pr,
        },
        {
          height: 'auto',
          adaptive: true,
        }
      );
    },
  },
  mounted() {
    console.log('rating-reviews trigger mounted')
    console.log('mustShowModal: ', this.mustShowModal)
    if (this.mustShowModal) {
      this.openModal()
    }
  },
}
</script>
